import { useState } from "react";
import "../App.css";
import logo from "../Assets/logo.jpg";
import axios, { formToJSON } from "axios";
import { main_link } from "../Connection/Connection";

const Login = (props) => {
  // console.log(main_link)

  const [email, setEmail] = useState();
  const [pass, setPass] = useState();
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState();
  const [error, setError] = useState(false);
  const setIsAuthenticated = props.setIsAuthenticated;
  const login = async (e) => {
    setLoading(true);
    e.preventDefault();
    setMsg(null);
    setError(false);

    if (!email || !pass || (email.trim() == "") | (pass.trim() == "")) {
      setLoading(false);
      setError(true);
      setMsg("All Feilds are Required");
      return 0;
    }

    try {
      const response = await axios.post(main_link + "login", {
        email,
        pass,
      });
      setLoading(false);
      setMsg(response.data);
      // console.log(response.data); // Handle token or other responses

      if (response.data.message !== "Login successfully") {
        setMsg(response.data.message);
        setError(true);
      }

      if (response.data.message == "Login successfully") {
        sessionStorage.setItem("user-data", JSON.stringify(response.data.data));
        sessionStorage.setItem("role_2", response.data.data["role_2"]);
        setMsg(null);
        setError(false);
        setIsAuthenticated(true);
      }
    } catch (error) {
      setLoading(false);
      setMsg(error);
      console.error("Login error:", error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* /.login-logo */}
        <div className="card card-outline card-primary ">
          <div className="card-header d-flex flex-column text-center justify-content-center align-items-center bg-white">
            <img className="brand-link" src={logo} alt="Shawns" />
            <span className="h2">Shawn's Barber Shop</span>
          </div>
          <div className="card-body">
            <p className="login-box-msg">Sign in to start your session</p>
            {error && (
              <div class="alert alert-danger alert-dismissible">{msg}</div>
            )}

            <form method="post">
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  onChange={(e) => setPass(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="row">
                {/* /.col */}
                {!loading && (
                  <div className="col-12">
                    <button
                      className="btn btn-primary btn-block"
                      onClick={login}
                    >
                      Sign In
                    </button>
                  </div>
                )}
                {loading && (
                  <div className="col-12">
                    <button className="btn btn-primary btn-block" disabled>
                      Signing in..
                    </button>
                  </div>
                )}
                {/* /.col */}
              </div>
            </form>
          </div>
          {/* /.card-body */}
        </div>
        {/* /.card */}
      </div>
    </div>
  );
};

export default Login;
